module.exports = __webpack_public_path__ + "img/border-all.211cb1ae.svg";